import React from 'react';
import { portfolioData } from '../data/mock';
import { ExternalLink, TrendingUp } from 'lucide-react';
import { Card } from './ui/card';
import { Badge } from './ui/badge';

const ProjectsSection = () => {
  const { projects } = portfolioData;

  return (
    <section id="projects" className="py-20 px-4 sm:px-6 lg:px-8 bg-[#0f1419]">
      <div className="max-w-6xl mx-auto">
        <div className="mb-12">
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-2">
            <span className="text-emerald-400 font-mono text-xl">04.</span> Featured Projects
          </h2>
          <div className="h-px bg-gray-700 mt-4"></div>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {projects.map((project) => (
            <Card
              key={project.id}
              className="bg-[#1a1d29] border-gray-800 hover:border-emerald-500/50 transition-all duration-300 group overflow-hidden flex flex-col"
            >
              <div className="p-6 flex-1 flex flex-col">
                <div className="flex items-start justify-between mb-4">
                  <div className="w-12 h-12 rounded-lg bg-emerald-500/10 flex items-center justify-center">
                    <TrendingUp size={24} className="text-emerald-400" />
                  </div>
                  {project.blogLink && (
                    <a
                      href={project.blogLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-gray-400 hover:text-emerald-400 transition-colors"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <ExternalLink size={20} />
                    </a>
                  )}
                </div>

                <h3 className="text-xl font-bold text-white mb-3 group-hover:text-emerald-400 transition-colors">
                  {project.title}
                </h3>
                <p className="text-gray-400 text-sm leading-relaxed mb-4 flex-1">
                  {project.description}
                </p>

                {project.metrics && project.metrics.length > 0 && (
                  <div className="flex flex-wrap gap-2 mb-4">
                    {project.metrics.map((metric, idx) => (
                      <span
                        key={idx}
                        className="px-2 py-1 bg-emerald-500/10 text-emerald-400 rounded text-xs font-medium"
                      >
                        {metric}
                      </span>
                    ))}
                  </div>
                )}

                <div className="flex flex-wrap gap-2 mt-auto">
                  {project.technologies.slice(0, 3).map((tech, idx) => (
                    <Badge
                      key={idx}
                      variant="outline"
                      className="border-gray-700 text-gray-400 text-xs"
                    >
                      {tech}
                    </Badge>
                  ))}
                </div>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProjectsSection;
